import React from 'react';
import { motion } from 'framer-motion';
export function LeafDivider({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center justify-center py-12 ${className}`} data-id="element-164">
      <div className="h-px bg-sage-300 w-16 md:w-32" data-id="element-165"></div>
      <motion.svg initial={{
      opacity: 0,
      rotate: -10
    }} whileInView={{
      opacity: 1,
      rotate: 0
    }} transition={{
      duration: 0.8
    }} viewport={{
      once: true
    }} className="mx-4 text-sage-500 w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-166">
        <path strokeLinecap="round" strokeLinejoin="round" d="M11.412 15.655L9.75 21.75l3.745-4.012M9.257 13.5H3.75l2.659-2.849m2.048-2.194L14.25 2.25 12 10.5h8.25l-4.707 5.043A8.027 8.027 0 0112 21.75c-2.676 0-5.216-.842-7.332-2.332L9.257 13.5z" data-id="element-167" />
      </motion.svg>
      <div className="h-px bg-sage-300 w-16 md:w-32" data-id="element-168"></div>
    </div>;
}